import Cookie from "@/utils/cookie";
import StorageHelper from "@/utils/storageHelper";
import Util from "@/utils/util";
import { AnalysisService } from "@/plugins/analysis";
import { useUserStore } from "@/stores/user";
import { useAnalysisStore } from "@/stores/analysis";
import userBiz from "@/process/userBiz";

export interface EnvironmentInitResult {
  env: "app" | "miniProgram" | "devMock" | "other";
  isLogin: boolean;
  isVip: boolean;
  productID: string | number;
}

export async function initMiniProgramEnvironment(): Promise<EnvironmentInitResult> {
  const userStore = useUserStore();
  const analysisStore = useAnalysisStore();

  let isLogin = Util.getUrlParameterByName("isLogin", location.search);
  let isVip = Util.getUrlParameterByName("isVip", location.search);
  let source = Util.getUrlParameterByName("source", location.search);
  let src1 = Util.getUrlParameterByName("src1", location.search);
  let src2 = Util.getUrlParameterByName("src2", location.search);
  let src3 = Util.getUrlParameterByName("src3", location.search);
  let src4 = Util.getUrlParameterByName("src4", location.search);

  let EncryptType = Util.getUrlParameterByName("EncryptType", location.search);
  let ClientHeaderInfo = Util.getUrlParameterByName("ClientHeaderInfo", location.search);
  let ProductID = Util.getUrlParameterByName("ProductID", location.search);

  // 如果 URL 上没有，就从本地取
  if (!EncryptType) EncryptType = Cookie.get("Client_EncryptType");
  if (!ClientHeaderInfo) ClientHeaderInfo = Cookie.get("ClientHeaderInfo");
  if (!ProductID) ProductID = Cookie.get("Client_ProductID");

  if (!isLogin) isLogin = StorageHelper.get("isLogin");
  if (!isVip) isVip = StorageHelper.get("isVip");

  const headerInfo = {
    EncryptType,
    ClientHeaderInfo,
    ProductID,
  };
  console.log("headerInfo:", headerInfo);

  analysisStore.setSource(source);
  analysisStore.setPlatform(Util.isInApp() ? "App" : Util.isInMiniProgram() ? "小程序" : "其他");
  analysisStore.setProductID(ProductID);
  analysisStore.setSrcParams(src1, src2, src3, src4);
  // 快照首屏完整 query，供页面重载（如支付返回）后还原地址参数
  analysisStore.setEntryQueryString(location.search);

  userStore.setVipState(isVip == "1");
  userStore.setLoginState(isLogin == "1" ? 1 : 0);
  userStore.setHeaderInfo(
    Object.assign({}, headerInfo, {
      domain: window.location.host.indexOf("babybus") > -1 ? ".babybus.com" : location.hostname,
    }),
  );

  if (userStore.isLogin == 1) {
    // 服务端不让启动调用积分接口，总有一天要调回来，哼
    // userStore.fetchAccountIntegral();
    userStore.fetchUserInfo().finally(() => {
      AnalysisService.setUserInfo(userStore.userInfo);
    });
    // 账号事件数据上报（每天仅一次），透传当前页面全量 query
    userBiz.reportAccountEventData(Util.parseQuery(location.search));
  }

  return {
    env: "miniProgram",
    isLogin: userStore.isLogin === 1,
    isVip: userStore.isVip,
    productID: ProductID || 0,
  };
}
